import '@levery/passkey/register'
import { LeveryConfig } from '@levery/apps'
import { type Levery, Mode, Storage } from '@levery/passkey'

const host = (() => {
  const url = new URL(LeveryConfig.getDialogHost())
  if (import.meta.env.DEV) url.port = window.location.port
  return url.href
})()

async function createConfig() {
  return {
    ...(await LeveryConfig.getSupportedConfig(
      import.meta.env.VITE_VERCEL_ENV === 'production' ? 'prod' : undefined,
    )),
    mode: Mode.dialog({
      host,
    }),
    storage: Storage.combine(Storage.localStorage(), Storage.cookie()),
  } as const satisfies Levery.Config
}

export type Config = Awaited<ReturnType<typeof createConfig>>

export let config: Config

let initialization: Promise<Config> | undefined

export function initialize(): Promise<Config> {
  initialization ??= createConfig().then((value) => {
    config = value
    return value
  })
  return initialization
}

// export const levery = Levery.create(config)
